import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * Какво се показва, когато нещо в екрана се е счупило при рисуване - най-често защото заявката е
 * върнала грешка и четенето на ресурса е хвърлило.
 *
 * Дотук такава грешка минаваше покрай всички предпазители и оставяше бял екран: страниците четат
 * ресурса в самото начало на компонента, а ErrorBoundary-то, което после рисуват, не хваща собственото
 * си хвърляне. Затова предпазителят стои над компонента, а не в него.
 *
 * Бутонът презарежда, защото use-async-resource пази и провалените заявки по параметри: същото
 * търсене би върнало същата грешка наум, без нова заявка. Промяна на търсенето или на филтъра обаче
 * е нов набор параметри - затова обвивката нулира предпазителя при всяка такава промяна и списъкът
 * се връща сам, без презареждане.
 */
export const LoadErrorComponent = ({ messageKey = 'tableLoadError' }: { messageKey?: string }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    return (
        <div className='error-component w-100 fw-bolder text-muted bg-light p-5 text-center'>
            <p>{t(messageKey)}</p>
            <Button variant='outline-secondary' onClick={() => window.location.reload()}>
                {t('reloadPage')}
            </Button>
        </div>
    );
};
